import { render, staticRenderFns } from "./SelectCentroCusto.vue?vue&type=template&id=282ffd7a&scoped=true"
import script from "./SelectCentroCusto.vue?vue&type=script&lang=js"
export * from "./SelectCentroCusto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ffd7a",
  null
  
)

export default component.exports